import { ApiRequestConfig } from 'api';
import { get } from 'features/api';
import { processFetchedResult } from '../utils/response-processor';

import type { FetchModels, ViewsModels } from '../types';

export function* fetchRelatedServices(
  { productId, regionCode }: FetchModels.RequestProps,
  options: ApiRequestConfig,
) {
  const data = yield* get<ViewsModels.RelatedServiceSuccessResponse>(
    'get-related-services',
    { productId, regionCode },
    {
      ...options,
    },
  );

  return {
    relatedServices: processFetchedResult(data as FetchModels.Response),
    baseEntityIds: 'baseEntityIds' in data ? data.baseEntityIds : [],
  };
}
